import React, { useId } from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import Svg, { Defs, LinearGradient, Rect, Stop } from 'react-native-svg';

import { MainUserIcon } from '../../../assets';

const DESIGN_WIDTH = 98;
const DESIGN_HEIGHT = 42;

const BORDER_COLOR = 'rgba(255, 209, 77, 0.55)';
const BORDER_WIDTH = 1;
const FILL_TOP = '#21170F';
const FILL_BOTTOM = '#0A0503';

const ICON = { x: 14, y: 12, w: 16, h: 18 };
const TEXT = { x: 33, w: 50 };
const TITLE = { y: 8, font: 11, line: 13.2 };
const VALUE = { y: 22, font: 10, line: 12 };

type Props = {
	title: string;
	value: string;
	width: number;
};

export const TablePlayersBadge = ({ title, value, width }: Props) => {
	const uid = useId().replace(/[^a-zA-Z0-9]/g, '');

	if (width <= 0) return null;

	const scale = width / DESIGN_WIDTH;
	const height = DESIGN_HEIGHT * scale;
	const stroke = BORDER_WIDTH * scale;
	const radius = height / 2;
	const fillId = `tableBadgeFill${uid}`;

	return (
		<View style={[styles.root, { width, height, borderRadius: radius }]} pointerEvents='none'>
			<Svg width={width} height={height} style={StyleSheet.absoluteFill}>
				<Defs>
					<LinearGradient id={fillId} x1='0' y1='0' x2='0' y2='1'>
						<Stop offset='0' stopColor={FILL_TOP} />
						<Stop offset='1' stopColor={FILL_BOTTOM} />
					</LinearGradient>
				</Defs>
				<Rect
					x={stroke / 2}
					y={stroke / 2}
					width={width - stroke}
					height={height - stroke}
					rx={radius - stroke / 2}
					ry={radius - stroke / 2}
					fill={`url(#${fillId})`}
					stroke={BORDER_COLOR}
					strokeWidth={stroke}
				/>
			</Svg>

			<Image
				source={MainUserIcon}
				resizeMode='contain'
				style={{
					position: 'absolute',
					left: ICON.x * scale,
					top: ICON.y * scale,
					width: ICON.w * scale,
					height: ICON.h * scale,
				}}
			/>

			<Text
				numberOfLines={1}
				style={[
					styles.title,
					{
						left: TEXT.x * scale,
						top: TITLE.y * scale,
						width: TEXT.w * scale,
						fontSize: TITLE.font * scale,
						lineHeight: TITLE.line * scale,
					},
				]}
			>
				{title}
			</Text>

			<Text
				numberOfLines={1}
				style={[
					styles.value,
					{
						left: TEXT.x * scale,
						top: VALUE.y * scale,
						width: TEXT.w * scale,
						fontSize: VALUE.font * scale,
						lineHeight: VALUE.line * scale,
					},
				]}
			>
				{value}
			</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		overflow: 'visible',
		shadowColor: '#000000',
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.6,
		shadowRadius: 3,
		elevation: 4,
	},
	title: {
		position: 'absolute',
		color: '#FFFFFF',
		fontFamily: 'Sofia Sans',
		fontWeight: '500',
		textAlign: 'center',
		includeFontPadding: false,
	},
	value: {
		position: 'absolute',
		color: '#FFFFFF',
		fontFamily: 'Sofia Sans',
		fontWeight: '600',
		textAlign: 'center',
		includeFontPadding: false,
	},
});

export default TablePlayersBadge;
